// Share functionality
import { currentCategory, setCurrentCategory, setExpandedStoryId } from './state.js';
import { showToast } from './utils.js';

export async function shareStory(storyId, event) {
  event.stopPropagation();

  try {
    const shareUrl = `${window.location.origin}${window.location.pathname}?story=${storyId}&category=${currentCategory}`;
    await navigator.clipboard.writeText(shareUrl);
    showToast('Link copied to clipboard!');

    const btn = event.currentTarget;
    btn.classList.add('active');
    setTimeout(() => btn.classList.remove('active'), 1000);
  } catch (error) {
    console.error('Failed to copy link:', error);
    try {
      const shareUrl = `${window.location.origin}${window.location.pathname}?story=${storyId}&category=${currentCategory}`;
      const tempInput = document.createElement('input');
      tempInput.value = shareUrl;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      showToast('Link copied to clipboard!');
    } catch (fallbackError) {
      showToast('Failed to copy link', 'error');
    }
  }
}

export function handleSharedLink() {
  const params = new URLSearchParams(window.location.search);
  const sharedStoryId = params.get('story');
  const sharedCategory = params.get('category');
  
  if (sharedStoryId && sharedCategory) {
    setCurrentCategory(sharedCategory);
    setExpandedStoryId(sharedStoryId);
    window.history.replaceState({}, '', window.location.pathname);
    return true;
  }
  return false;
}
